import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Chat from './Chat.js';
import SaaSProductLandingPage from "demos/SaaSProductLandingPage.js";
import TermsOfServicePage from "pages/TermsOfService.js";
import PrivacyPolicyPage from "pages/PrivacyPolicy.js";
import LandingPage from "./LandingPage.js";
import NewHomepage from "./NewHomepage.js";
import AccountDataDeletion from "pages/AccountDataDeletion.js";
import AccountDataDeletionIOS from "pages/AccountDataDeletionIOS.js";
import Privacy from "./pages/Privacy.js";
import Terms from "./pages/Terms.js";
import AnalyzeMe from "./AnalyzeMe.js";
// import AboutUsPage from "pages/AboutUs.js";

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Default Route */}
          <Route path="/chat" element={<Chat />} />
          <Route path="/analyzeMe" element={<AnalyzeMe />} />
          <Route path="/newLanding" element={<LandingPage />} />
          <Route path="/old-landing" element={<SaaSProductLandingPage />} />
          {/* Main Landing Page */}
          <Route path="/" element={<NewHomepage />} />

          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />

          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          <Route path="/accountDataDeletionRequestAndroid" element={<AccountDataDeletion />} />
          <Route path="/accountDataDeletionRequestIOS" element={<AccountDataDeletionIOS />} />
          {/* <Route path="/about" element={<AboutUsPage />} /> */}

        </Routes>
      </Router>
    </>
  );
}

export default App;
